import React from 'react';
import { Col, Row, Container, Card } from 'react-bootstrap';
import mainStyles from '../styles/main-panel.less';
import styles from '../styles/file-uploader.less';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function WelcomeBar(_ref) {
  var stepper = _ref.stepper,
    buttons = _ref.buttons;
  return /*#__PURE__*/_jsx(Container, {
    fluid: true,
    children: /*#__PURE__*/_jsxs(Row, {
      className: mainStyles['welcome-bar'],
      children: [/*#__PURE__*/_jsx(Col, {
        md: 3,
        children: /*#__PURE__*/_jsx(Card, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "d-flex align-items-start",
            children: [/*#__PURE__*/_jsx("div", {
              className: "align-self-center me-3",
              style: {
                'display': 'inline-block'
              },
              children: /*#__PURE__*/_jsxs("span", {
                className: "fa-stack fa-4x ".concat(mainStyles['welcome-icon']),
                children: [/*#__PURE__*/_jsx("i", {
                  className: "fa fa-circle fa-stack-2x ".concat(mainStyles['welcome-icon-fill'])
                }), /*#__PURE__*/_jsx("i", {
                  className: "fa fa-circle-thin fa-stack-2x ".concat(mainStyles['welcome-icon-stroke'])
                }), /*#__PURE__*/_jsx("i", {
                  className: "fa fa-plus fa-stack-1x ".concat(mainStyles['welcome-icon-icon'])
                })]
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex-grow-1",
              children: [/*#__PURE__*/_jsx("h5", {
                className: mainStyles['user-greeting-heading'],
                children: "Create"
              }), /*#__PURE__*/_jsx("span", {
                className: mainStyles['user-greeting-message'],
                children: "Upload, transform, and visualize"
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        md: 9,
        children: /*#__PURE__*/_jsx(Card, {
          children: /*#__PURE__*/_jsxs("div", {
            className: styles['stepper-container'],
            children: [/*#__PURE__*/_jsx("div", {
              className: "col-md-9 pt-4",
              children: stepper
            }), /*#__PURE__*/_jsx("div", {
              className: styles['stepper-buttons'],
              children: buttons
            })]
          })
        })
      })]
    })
  });
}